import { createAction } from '@reduxjs/toolkit';
import { z } from 'zod/v3';

const emptyStepsSchema = z.array(z.never()).max(0).default([]);

export const newRecipeStepsSchema = z.object({
  stepSpeedOven: emptyStepsSchema,
  stepCombiOvenTSI: emptyStepsSchema,
  stepCombiOvenCMAX: emptyStepsSchema,
  stepLastroToro: emptyStepsSchema,
  stepConvectionOven: emptyStepsSchema,
  stepEquipment: emptyStepsSchema,
});

export type NewRecipeStepsState = z.infer<typeof newRecipeStepsSchema>;

export const createNewRecipeStepsState = (): NewRecipeStepsState =>
  newRecipeStepsSchema.parse({});

export const resetRecipeSteps = createAction(
  'recipeSteps/resetForCreation',
  () => ({ payload: createNewRecipeStepsState() })
);

type ResetRecipeStepsDispatch = (
  action: ReturnType<typeof resetRecipeSteps>
) => unknown;

export const resetRecipeStepsForCreation = (
  dispatch: ResetRecipeStepsDispatch
) => {
  dispatch(resetRecipeSteps());

  if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem('persist:steps');
  }
};
